"use strict";

class DeveloperSalesOtpEditorController {

    constructor($window, $sce, Upload, SSAwsService, SSHttpService, SSUtilService, SSAlertService, SSConfigService, SSAppService, SSUserService, OTPService, $timeout) {
        const self = this;

        self.$window = $window;
        self.$timeout = $timeout;
        self.sce = $sce;

        self.Upload = Upload;
        self.SSAwsService = SSAwsService;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;

        self.PROPERTY_DOCUMENT_TYPE_FORM = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_FORM;
        self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED;

        self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM;
        self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM;
        self.PROPERTY_DOCUMENT_KIND_PDI_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PDI_FORM;
        self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS;
        self.PROPERTY_DOCUMENT_KIND_OTP = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTP;
        self.PROPERTY_DOCUMENT_KIND_ANNEXES = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEXES;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_A = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_A;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_B3 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_B3;

        self.ASSET_MODEL_BUYER_DOCUMENT = SHOWSUITE.ASSET_MODEL_BUYER_DOCUMENT;
        self.PROPERTY_DOCUMENT_FORMAT_PDF = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_PDF;
        self.ASSET_MODEL_PROPERTY_DOCUMENT = SHOWSUITE.ASSET_MODEL_PROPERTY_DOCUMENT;
        self.PROPERTY_DOCUMENT_FORMAT_HTML = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_HTML;

        self.ASSET_MODEL_SALE_DOCUMENT = SHOWSUITE.ASSET_MODEL_SALE_DOCUMENT;

        self.SALE_STATUS_APPROVED = SHOWSUITE.SALE_STATUS_APPROVED;
        self.SALE_STATUS_OTP = SHOWSUITE.SALE_STATUS_OTP;

        self.data = SHOWSUITE.data;
        self.sale_id = SHOWSUITE.data.sale_id;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        self.documents = [];
        self.file_uri = '';

        self.editor_pages = [];
        // By default first page is loaded
        // Increment 'editor_total_pages' in 'insertNewPage'
        self.editor_total_pages = 1;
        self.editor_current_page = 1;

        self.ADVANCED_OPTIONS = [];
        self.PROPERTY_OPTIONS = [];
        self.UNIT_OPTIONS = [];
        self.BUYER_OPTIONS = [];
        self.SIGNATURE_OPTIONS = [];

        self.getSale();

        self.setAdvancedOptions();
        self.setPropertyOptions();
        self.setUnitOptions();
        self.setBuyerOptions();
        self.setSignatureOptions();
    }

    setAdvancedOptions(){
        const self = this;
        
        self.ADVANCED_OPTIONS.push({id:'advance_option_1', title:'Date', type:'date', label:'[Date]', code:"{{$current_date->format('d/m/Y')}}"});
    }

    setPropertyOptions(){
        const self = this;

        self.PROPERTY_OPTIONS.push({id:'property_1', title:'Property Name', type:'text', label:'[Property Name]', code:'{{$property->name}}'});
    }

    setUnitOptions(){
        const self = this;

        self.UNIT_OPTIONS.push({id:'unit_1', title:'Unit Number', type:'text', label:'[Unit Number]', code:'{{getFullUnitNumber($unit)}}'});
        // Images [need img tag handling]
        // TODO: Image tags are not working properly
        self.UNIT_OPTIONS.push({id:'unit_2', title:'Unit Floor Plan Image', type:'image', label:'[Unit Floor Plan Image]', code:self.renderHtml("<img src='{{$unitFloorplanAssetUrl}}'>")});
        self.UNIT_OPTIONS.push({id:'unit_3', title:'Unit Annex A Image', type:'image', label:'[Unit Annex A Image]', code:self.renderHtml("<img src='{{$unitAnnexAAssetUrl}}'>")});
    }

    setBuyerOptions(){
        const self = this;

        self.BUYER_OPTIONS.push({id:'buyer_1', title:'Buyer Identity Type', type:'text', label:'[Buyer Identity Type]', code:'{{getBuyerIdentityTypeName($buyer->individual->identity_type)}}'});
        self.BUYER_OPTIONS.push({id:'buyer_2', title:'Buyer Salutation', type:'text', label:'[Buyer Salutation]', code:'{{getSalutationName($buyer->individual->title)}}'});
        self.BUYER_OPTIONS.push({id:'buyer_3', title:'Buyer Name', type:'text', label:'[Buyer Name]', code:'{{getUserDisplayName($broker->user)}}'});
        self.BUYER_OPTIONS.push({id:'buyer_4', title:'Buyer Gender', type:'text', label:'[Buyer Gender]', code:'{{getGenderName($buyer->individual->gender)}}'});
        self.BUYER_OPTIONS.push({id:'buyer_5', title:'Buyer Nationality', type:'text', label:'[Buyer Nationality]', code:'{{getNationalityName($buyer->individual->nationality)}}'});
        self.BUYER_OPTIONS.push({id:'buyer_6', title:'Buyer Marital Status', type:'text', label:'[Buyer Marital Status]', code:'{{getMaritalStatusName($buyer->individual->marital_status)}}'});
    }

    setSignatureOptions(){
        const self = this;

        self.SIGNATURE_OPTIONS.push({id:'buyer_sign_1', title:'Buyer Signatures', type:'text', label:'[Buyer Signatures]', code:'@{BUYER1_SIGNATURE}'});
        self.SIGNATURE_OPTIONS.push({id:'buyer_sign_2', title:'All Signatures', type:'text', label:'[All Signatures]', code:'@{ALL_SIGNATURES}'});
    }

    getOptionById(id){
        const self = this;

        let option = '';

        try{
            option = self.ADVANCED_OPTIONS.find(x => x.id == id);
            if(!option){
                option = self.PROPERTY_OPTIONS.find(x => x.id == id);
            }
            if(!option){
                option = self.SIGNATURE_OPTIONS.find(x => x.id == id);
            }
            if(!option){
                option = self.BUYER_OPTIONS.find(x => x.id == id);
            }
            if(!option){
                option = self.UNIT_OPTIONS.find(x => x.id == id);
            }
            
            return option;
        }
        catch(ex){
            console.log(ex);
        }
    }

    getSale(){
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.sales.length > 0){
                self.sale = response.data.sales[0];
                if(self.sale.status == self.SALE_STATUS_APPROVED){
                    var regenerate = false;
                }
                else if(self.sale.status == self.SALE_STATUS_OTP){
                    var regenerate = true;
                }

                self.editOTP(regenerate);
            }
        });
    }

    editOTP(regenerate){
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/generate-otp';

        let params = {
          regenerate: regenerate,
          mode: 'html',
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.contents){
                self.initEditorData(response.data.contents);
            }
        });
    }

    initEditorData(data) {
        const self = this;

        let _data = $($.parseHTML('<div>' + data + '</div>'));
        let nodes = _data.find('.container');
        let pages = nodes.length;

        // Destroy editor if already exist
        if ($('div#froala-editor').data('froala.editor')) {
            $('div#froala-editor').froalaEditor('destroy');
        }

        if(pages > 1){
            for(var index = 0; index < nodes.length; index++){
                self.editor_pages[index] = nodes[index].innerHTML;
            }

            self.editor_total_pages = pages;
            self.editor_current_page = 1;

            // Display first page
            $('div#froala-editor').html(self.editor_pages[0]);
            self.updatePageCount(self.editor_current_page, self.editor_total_pages);
        }
        else{
            if(!data){
                data = '<span>Add contents here</span>';
                self.editor_pages.push(data);
            }
            $('div#froala-editor').html($($.parseHTML(data)));
        }

        // Initialize/Re-initialize editor widgets
        $.FroalaEditor.DefineIcon('close', {NAME: 'remove'});
        $.FroalaEditor.RegisterCommand('close', {
            title: 'Close',
            focus: false,
            undo: true,
            refreshAfterCallback: true,
            callback: function () {
                if ($('div#froala-editor').data('froala.editor')) {
                    $('div#froala-editor').froalaEditor('destroy');
                }
                $('#document_container').css({'display': 'none'});
                self.redirectBack();
            }
        });

        $.FroalaEditor.DefineIcon('save', {NAME: 'save'});
        $.FroalaEditor.RegisterCommand('save', {
            title: 'Save',
            focus: true,
            undo: true,
            refreshAfterCallback: true,
            callback: function () {

                self.updateCurrentPageContent(self.editor_current_page-1);

                let content = '';

                jQuery.each(self.editor_pages, function(index, pageContent){
                    content += '<div class="container">' + pageContent + '</div>';
                });

                if (!content) return;

                try {
                    if ($('div#froala-editor').data('froala.editor')) {
                        $('div#froala-editor').froalaEditor('destroy');
                    }

                    $('#document_container').css({'display': 'none'});

                    // Unescape special characters
                    content = _.unescape(content);

                    if(content){
                        self.updateDocument(content);
                    }
                    
                } catch (ex) {
                    console.log(ex);
                }
            }
        });

        $.FroalaEditor.DefineIcon('insertNewPage', {NAME: 'Insert New Page', template: 'text'});
        $.FroalaEditor.RegisterCommand('insertNewPage', {
            title: 'Insert New Page',
            icon: 'insertNewPage',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            callback: function (cmd, val) {

                let content = $('div#froala-editor').froalaEditor('html.get');

                self.updateCurrentPageContent(self.editor_current_page-1);

                self.editor_total_pages += 1;
                self.editor_current_page = self.editor_total_pages;

                let newPageContent = '<span>Add contents here</span>';

                $('div#froala-editor').froalaEditor('html.set', newPageContent);

                self.updatePageCount(self.editor_current_page, self.editor_total_pages);

                // Push this newly inserted page to pages array
                self.editor_pages.push(newPageContent);

            },
            // Callback on refresh.
            refresh: function ($btn) {
            },
            // Callback on dropdown show.
            refreshOnShow: function ($btn, $dropdown) {
                this.size.refresh(); // TODO: not working :-(
            }
        });

        $.FroalaEditor.DefineIcon('removeCurrentPage', {NAME: 'Remove Current Page', template: 'text'});
        $.FroalaEditor.RegisterCommand('removeCurrentPage', {
            title: 'Remove Current Page',
            icon: 'removeCurrentPage',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            callback: function (cmd, val) {
                
                // Don't remove, if there is only one page 
                if(self.editor_total_pages <= 1){
                    return;
                }

                // Remove current page: array.splice(index, numberOfValues);
                self.editor_pages.splice(self.editor_current_page-1, 1);

                self.editor_total_pages -= 1;
                self.editor_current_page = 1;

                // Display first page
                let content = self.editor_pages[0];
                if(!content){
                    content = '<span>Add content here</span>';
                }

                $('div#froala-editor').froalaEditor('html.set', content);

                // Set page count as: PAGE 1 OF X
                self.updatePageCount(self.editor_current_page, self.editor_total_pages);
            },
            // Callback on refresh.
            refresh: function ($btn) {
            },
            // Callback on dropdown show.
            refreshOnShow: function ($btn, $dropdown) {
                this.size.refresh(); // TODO: not working :-(
            }
        });

        // Advance Options Menu e.g Date
        $.FroalaEditor.DefineIcon('advancedOptions', {NAME: 'Insert Options', template: 'text'});
        $.FroalaEditor.RegisterCommand('advancedOptions', {
            title: 'Insert Options',
            type: 'dropdown',
            icon: 'advancedOptions',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            // Callback on refresh.
            refresh: function ($btn) {
            },
            // Callback on dropdown show.
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                let list = $dropdown.find('ul.fr-dropdown-list');
                // Remove previous 'innerHtml'
                $(list).html('');
                let listItems = '';
                let placeholders = self.ADVANCED_OPTIONS;
                      
                let commandName = 'advancedOptions';
                let buildListItem = function (id, title, label) {

                    let listItem = "<li><a class='fr-command' data-cmd=" + commandName +
                      " title=\"" + title + "\" data-param1=\"<span style='display:inline-block' class='code-mapping' id='" +
                      id + "'>" + label + "</span>\">" +
                      title + "</a></li>";
                     
                    return listItem;
                };

                jQuery.each(placeholders, function (index, placeholder) {
                    listItems += buildListItem(placeholder.id, placeholder.title, placeholder.code);
                });

                list.empty().append(listItems);

                if (!editorInstance.selection.inEditor()) {
                    // Move cursor position to end.
                    editorInstance.selection.setAtEnd(editorInstance.$el.get(0));
                    editorInstance.selection.restore();
                }
            }
        });

        // Insert Property Values Menu
        $.FroalaEditor.DefineIcon('insertPropertyOptions', {NAME: 'Insert Property', template: 'text'});
        $.FroalaEditor.RegisterCommand('insertPropertyOptions', {
            title: 'Insert Property',
            type: 'dropdown',
            icon: 'insertPropertyOptions',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            // Callback on refresh.
            refresh: function ($btn) {
            },
            // Callback on dropdown show.
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                // let id = $("button[data-cmd='insertPropertyOptions']").attr('id');
                // let list = $dropdown.find('#dropdown-menu-'+ id +'>ul.fr-dropdown-list');

                let list = $dropdown.find('ul.fr-dropdown-list');
                // Remove previous 'innerHtml'
                $(list).html('');
                let listItems = '';
                let placeholders = self.PROPERTY_OPTIONS;
                      
                let commandName = 'insertPropertyOptions';
                let buildListItem = function (id, title, label) {

                    let listItem = "<li><a class='fr-command' data-cmd=" + commandName +
                      " title=\"" + title + "\" data-param1=\"<span style='display:inline-block' class='code-mapping' id='" +
                      id + "'>" + label + "</span>\">" +
                      title + "</a></li>";
                     
                    return listItem;
                };

                jQuery.each(placeholders, function (index, placeholder) {
                    listItems += buildListItem(placeholder.id, placeholder.title, placeholder.code);
                });

                list.empty().append(listItems);

                if (!editorInstance.selection.inEditor()) {
                    // Move cursor position to end.
                    editorInstance.selection.setAtEnd(editorInstance.$el.get(0));
                    editorInstance.selection.restore();
                }
            }
        });

        // Unit Options Menu
        $.FroalaEditor.DefineIcon('insertUnitOptions', {NAME: 'Insert Unit', template: 'text'});
        $.FroalaEditor.RegisterCommand('insertUnitOptions', {
            title: 'Insert Unit',
            type: 'dropdown',
            icon: 'insertUnitOptions',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                 let editorInstance = this;

                let list = $dropdown.find('ul.fr-dropdown-list');
                // Remove previous 'innerHtml' if exists
                $(list).html('');
                let listItems = '';
                let placeholders = self.UNIT_OPTIONS;
                
                let commandName = 'insertUnitOptions';
                let buildListItem = function (id, title, label) {

                    let listItem = "<li><a class='fr-command' data-cmd=" + commandName +
                      " title=\"" + title + "\" data-param1=\"<span style='display:inline-block' class='code-mapping' id='" +
                      id + "'>" + label + "</span>\">" +
                      title + "</a></li>";
                     
                    return listItem;
                };

                jQuery.each(placeholders, function (index, placeholder) {
                    listItems += buildListItem(placeholder.id, placeholder.title, placeholder.code);
                });

                list.empty().append(listItems);

                if (!editorInstance.selection.inEditor()) {
                    // Move cursor position to end.
                    editorInstance.selection.setAtEnd(editorInstance.$el.get(0));
                    editorInstance.selection.restore();
                }
            }
        });

        // Buyer Options Menu
        $.FroalaEditor.DefineIcon('insertBuyerOptions', {NAME: 'Insert Buyer', template: 'text'});
        $.FroalaEditor.RegisterCommand('insertBuyerOptions', {
            title: 'Insert Buyer',
            type: 'dropdown',
            icon: 'insertBuyerOptions',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                 let editorInstance = this;

                let list = $dropdown.find('ul.fr-dropdown-list');
                // Remove previous 'innerHtml' if exists
                $(list).html('');
                let listItems = '';
                let placeholders = self.BUYER_OPTIONS;
                
                let commandName = 'insertBuyerOptions';
                let buildListItem = function (id, title, label) {

                    let listItem = "<li><a class='fr-command' data-cmd=" + commandName +
                      " title=\"" + title + "\" data-param1=\"<span style='display:inline-block' class='code-mapping' id='" +
                      id + "'>" + label + "</span>\">" +
                      title + "</a></li>";
                     
                    return listItem;
                };

                jQuery.each(placeholders, function (index, placeholder) {
                    listItems += buildListItem(placeholder.id, placeholder.title, placeholder.code);
                });

                list.empty().append(listItems);

                if (!editorInstance.selection.inEditor()) {
                    // Move cursor position to end.
                    editorInstance.selection.setAtEnd(editorInstance.$el.get(0));
                    editorInstance.selection.restore();
                }
            }
        });

        // Signatures Menu
        $.FroalaEditor.DefineIcon('insertSignatures', {NAME: 'Insert Signature', template: 'text'});
        $.FroalaEditor.RegisterCommand('insertSignatures', {
            title: 'Insert Signatures',
            type: 'dropdown',
            icon: 'insertSignatures',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                 let editorInstance = this;

                // let id = $("button[data-cmd='insertPropertyOptions']").attr('id');
                // console.log('id');
                // console.log(id);
                // let list = $dropdown.find('#dropdown-menu-'+ id +'>ul.fr-dropdown-list');

                let list = $dropdown.find('ul.fr-dropdown-list');
                // Remove previous 'innerHtml'
                $(list).html('');
                let listItems = '';
                let placeholders = self.SIGNATURE_OPTIONS;
                
                let commandName = 'insertSignatures';
                let buildListItem = function (id, title, label) {

                    let listItem = "<li><a class='fr-command' data-cmd=" + commandName +
                      " title=\"" + title + "\" data-param1=\"<span style='display:inline-block' class='code-mapping' id='" +
                      id + "'>" + label + "</span>\">" +
                      title + "</a></li>";
                     
                    return listItem;
                };

                jQuery.each(placeholders, function (index, placeholder) {
                    listItems += buildListItem(placeholder.id, placeholder.title, placeholder.code);
                });

                list.empty().append(listItems);

                if (!editorInstance.selection.inEditor()) {
                    // Move cursor position to end.
                    editorInstance.selection.setAtEnd(editorInstance.$el.get(0));
                    editorInstance.selection.restore();
                }
            }
        });

        var buttons = [
                'paragraphFormat', 'fontFamily', 'fontSize', 'bold', 'italic', 'underline', 'strikeThrough',
                '|', 'subscript', 'superscript', 'color',
                '|', 'paragraphFormat', 'paragraphStyle', 'inlineStyle', 'align',
                '|', 'formatOL', 'formatUL', 'outdent', 'indent', 'selectAll',
                '|', 'insertLink', 'insertImage', 'insertVideo', 'insertTable',
                '-', 'insertHR', 'insertFile', 'clearFormatting',
                '|', 'html',
                '|', 'undo', 'redo',
                '|', 'save', 'fullscreen', 'close',
                '-', 'advancedOptions', '|', 'insertPropertyOptions', '|', 'insertUnitOptions',
                '|', 'insertBuyerOptions', '|', 'insertSignatures', '|', 'insertNewPage', '|', 'removeCurrentPage'
            ];

        // Init Froala Editor
        let froalaEditor = $('div#froala-editor').froalaEditor({
            key: 'HH3E1A4A4wB1B1E1D2E1E4I3B2A9A5jdpvmhitjzF4bmn==',
            // width: 2480,
            // height: 3508,
            charCounterCount: true,
            placeholderText: '',
            //enter: $.FroalaEditor.ENTER_BR,
            iframe: true,
            
            toolbarButtons: buttons,
            toolbarButtonsMD: buttons,
            toolbarButtonsSM: buttons,
            toolbarButtonsXS: buttons,

            fontFamilySelection: true,
            fontSizeSelection: true,
            paragraphFormatSelection: true,
            htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr'],
            htmlRemoveTags: []
        });

        // Image handling
        // If image is uploaded then convert it to base64 and insert base64 string in place
        froalaEditor.on('froalaEditor.image.beforeUpload', function (e, editor, files) {
            if (files.length) {
                // Create a File Reader.
                let reader = new FileReader();

                // Set the reader to insert images when they are loaded.
                reader.onload = function (e) {
                    let result = e.target.result;
                    editor.image.insert(result, null, null, editor.image.get());
                };

                // Read image as base64.
                reader.readAsDataURL(files[0]);
            }

            editor.popups.hideAll();

            // Stop default upload chain.
            return false;
        });
    }

    editorBackPage(){
        const self = this;

        if(self.editor_current_page == 1){
            return;
        }

        self.updateCurrentPageContent(self.editor_current_page-1);

        self.editor_current_page -= 1;

        let data = self.editor_pages[self.editor_current_page-1];
        self.updatePageCount(self.editor_current_page, self.editor_total_pages);

        self.initEditorData(data);
    }

    editorNextPage(){
        const self = this;
        console.log('next page');
        if(self.editor_current_page == self.editor_total_pages){
            return;
        }
        self.updateCurrentPageContent(self.editor_current_page-1);
        self.editor_current_page += 1;

        let data = self.editor_pages[self.editor_current_page-1];

        self.updatePageCount(self.editor_current_page, self.editor_total_pages);
        
        self.initEditorData(data);
    }

    updateCurrentPageContent(current_page){
        const self = this;

        let content = $('div#froala-editor').froalaEditor('html.get');
        if(content){
            if(!self.editor_pages){
                self.editor_pages.push(content);
            }
            else{
                self.editor_pages[current_page] = content;
            }
        }
    }

    updatePageCount(current_page, total_pages){
        const self = this;

        $('#current-page').text(current_page);
        $('#total-pages').text(total_pages);
    }

    updateDocument(content){
        const self = this;

        let message = 'Please enter the One-Time verification code which has been send to your registered phone number.';
        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function(data){
      
            let url = 'sec/developer/sales/' + self.sale_id + '/generate-otp';

            if(self.sale.status == self.SALE_STATUS_APPROVED){
                var regenerate = false;
            }
            else if(self.sale.status == self.SALE_STATUS_OTP){
                var regenerate = true;
            }

            let params = {
              mode: 'pdf',
              contents: content,
              regenerate: regenerate,
            };

            loading(true);
            self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.hideModals();
                self.info_message = 'OTP updated successfully';
                self.showInfoModal = true;
                $('#infoMessageModal').modal('show');
                if(response.data && response.data.sale_document){
                    self.viewOTP(response.data.sale_document);
                }
            });
        }, message);
    }

    viewOTP(sale_document) {
        const self = this;

        if (sale_document) {
          let url = 'sec/assets/presigned-url';
          let params = {
            model: self.ASSET_MODEL_SALE_DOCUMENT,
            id: sale_document.id
          };

          loading(true);
          self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
              self.SSAlertService.parseAndDisplayError(response);
              return;
            }

            // Open OTP in new tab
            window.open(response.data.presigned_url, '_blank');
          });
        }
    }

    renderHtml(content) {
        const self = this;

        // WEB-3597 — allow-list sanitise rich text before trusting it for ng-bind-html.
        return self.sce.trustAsHtml(window.ssSanitizeHtml(content));
    }

    onInfoMessage(){
        const self = this;

        self.hideModals();
        self.redirectBack();
    }

    redirectBack(){
        const self = this;

        if (self.data.redirect) {
            self.$window.location = '/' + self.data.redirect;
        } else {
            self.$window.location = '/developer/sales/applications';
        }        
    }

    hideModals() {
        const self = this;

        self.showInfoModal = false;
        
        if ($('#infoMessageModal').is(':visible')) $('#infoMessageModal').modal('hide');
    }

}

DeveloperSalesOtpEditorController.$inject = ['$window', '$sce', 'Upload', 'SSAwsService', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSConfigService', 'SSAppService', 'SSUserService', 'OTPService', '$timeout'];
app.controller('DeveloperSalesOtpEditorController', DeveloperSalesOtpEditorController);

